module.exports = __webpack_public_path__ + "img/threeBlue.74155530.jpg";